(function() {
    'use strict';
    angular.module('cabinFlightAdmin').config(config);

    function config($stateProvider) {
        $stateProvider.state('cabinFlightAdmin', {
            url: '/cabin-flight-admin',
            views: {
                'cabinFlightAdminView': {
                    templateUrl: 'cabin-flight-admin/views/cabin-flight-admin.tpl.html',
                    controller: 'cabinFlightAdminCtrl',
                    controllerAs: 'cabinFlightAdmin'
                }
            }
        });
    }
}());